import { useEffect } from 'react'
import QuestionKey from '../Questions/question-key'
import { fireReactGAEvent } from '../components/Questions/utils'

export const useQuestionVisibilityTracking = (questionKey: QuestionKey) => {
  useEffect(() => {
    fireReactGAEvent({
      category: 'Application Form',
      action: 'Question Visible',
      label: `qst.${questionKey}`,
      nonInteraction: true
    })
  }, [])
}
